// Shorthand backgroundImage style
export const bgImage = src => {
  return { backgroundImage: `url(${src})` }
}
